// Classes.
import { BaseLocator } from './../locators/base.locator';
import { LevelLocatorComponent } from './../locators/level.locator-component';
import { DateLocatorComponent } from './../locators/date.locator-component';
import { WithResultsLocatorComponent } from './../locators/with-results.locator-component';
import { LiveLocatorComponent } from './../locators/live.locator-component';
import { DisciplineLocatorComponent } from './../locators/discipline.locator-component';
import { SortingLocatorComponent } from './../locators/sorting.locator-component';
import { DetailedLocatorComponent } from './../locators/detailed.locator-component';
import { BooleanLocatorComponent } from './boolean.locator-component';
import { CategoryIdLocatorComponent } from './categoryid.locator-component';
import { StringLocatorComponent } from './string.locator-component';



export class EventListLocator extends BaseLocator {

  public level: LevelLocatorComponent;
  public startDate: DateLocatorComponent;
  public endDate: DateLocatorComponent;
  public withRes: WithResultsLocatorComponent;
  public live: LiveLocatorComponent;
  public discipline: DisciplineLocatorComponent;
  public search: StringLocatorComponent;
  public sort: SortingLocatorComponent;
  public detailed: DetailedLocatorComponent;
  public featured: BooleanLocatorComponent;
  public category: CategoryIdLocatorComponent;
  public country: StringLocatorComponent;
  public event: StringLocatorComponent;
  public worldrecordstatus: CategoryIdLocatorComponent;
  public worldrankingevent: CategoryIdLocatorComponent;
  public embedfiles: BooleanLocatorComponent;
  public catDivision: CategoryIdLocatorComponent;
  constructor() {
    super('eventList');
    this.addComponentByType('level', 'level');
    this.addComponentByType('discipline', 'discipline');
    this.addComponentByType('date', 'startDate');
    this.addComponentByType('date', 'endDate');
    this.addComponentByType('results', 'withRes');
    this.addComponentByType('live', 'live');
    this.addComponentByType('live', 'featured');
    this.addComponentByType('catcode', 'category');
    this.addComponentByType('country', 'country');
    this.addComponentByType('search', 'search');
    this.addComponentByType('category', 'category');
    this.addComponentByType('event', 'event');
    this.addComponentByType('sort', 'sort');
    this.addComponentByType('worldrecordstatus', 'worldrecordstatus', "WorldRecordStatus", "worldrecordstatus");
    this.addComponentByType('worldrankingevent', 'worldrankingevent', "WorldRankingEvent", "worldrankingevent");
    this.addComponentByType('embedfiles', 'embedfiles', "EmbedFiles", "embedfiles");
    this.addComponentByType('detailed');
    this.addComponentByType('catid', 'catDivision');
    this.sort.setValidSortings(['date', 'level', 'noc']);
  }
}

